import * as React from 'react';

import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

const options = [
    { value: '4pt', label: 'Very Small' },
    { value: '5pt', label: 'Small' },
    { value: '6pt', label: 'Normal' },
    { value: '7pt', label: 'Large' },
    { value: '8pt', label: 'Very Large' },
];

export const StepLabelFontSize = () => {
    const [value, setValue] = React.useState<string>('6pt');

    const onChange = (value: string) => {
        setValue(value);
        apiProvider.changeStepLabelFontSize({ font_size: value });
        apiProvider.rebuildPVDiagram({});
    };

    React.useEffect(() => {
        setValue(apiProvider.getStepLabelFontSize().font_size);
    }, []);

    React.useEffect(() => {
        const listener = () => {
            const settings = apiProvider.getStepLabelFontSize();
            setValue (settings.font_size);
        };

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    return (
        <Dropdown
            options={options}
            onChange={onChange}
            value={value} />
    );
};
